// extracted by mini-css-extract-plugin
module.exports = {"itemVal":"itemValue_itemVal__3mj8Z"};